import {ESectors, type TSectorPair} from "../../../client/src/shared/Consts"

export enum Currency {
    CAD = 0,
    USD = 1,
}

export type TFrequency = "m"|"q"|"s"|"a";

export interface IPrice {
    _id:string;
    currency:Currency;
    name?:string;
    price?:number;
    yield?:number;
    date?:string;           // dividend date
    sector?:ESectors;
    sectors?:TSectorPair[];
    ex?:number;
    vd?:boolean;            // variable dividend
    frequency:TFrequency
    payout?:number;
}
